import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppConfigProvider, Auth0ProviderWithNavigate, AuthenticationGuard, EnvConfigProvider } from "rwo-react";
import { App } from "./App";
import "./assets/css/App.css";
import { LoadingPage } from "./pages";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);
const client = new QueryClient();

root.render(
  <React.StrictMode>
    <EnvConfigProvider config={process.env as Record<string, string>} devUri="http://localhost:3000">
      <QueryClientProvider client={client}>
        <BrowserRouter>
          <Auth0ProviderWithNavigate>
            <AuthenticationGuard loadingPage={<LoadingPage />}>
              <AppConfigProvider>
                <App />
              </AppConfigProvider>
            </AuthenticationGuard>
          </Auth0ProviderWithNavigate>
        </BrowserRouter>
      </QueryClientProvider>
    </EnvConfigProvider>
  </React.StrictMode>,
);
